import { render } from "./notice-modal.vue?vue&type=template&id=2487613a&scoped=true"
import script from "./notice-modal.vue?vue&type=script&lang=js"
export * from "./notice-modal.vue?vue&type=script&lang=js"

import "./notice-modal.vue?vue&type=style&index=0&id=2487613a&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lhc\\hk-lottery-lhc-ui\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2487613a"]])

export default __exports__